// Coercion primitives shared by the message-builder derivation helpers.
// Each returns a normalized value or null — never throws.

export function stringOr(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}

export function numberOr(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function epochMsOr(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    // Accept ISO-ish strings by delegating to Date.parse. If the string is
    // already a numeric literal, prefer that.
    const asNum = Number(value);
    if (Number.isFinite(asNum)) return asNum;
    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
